import {LeadGenerationOptions, PdfResponse, QuoteBelfius, QuoteSimulation} from "./types/lead-configuration-option.types";
import {CreateLeadDto, CreateLeadResultDto} from "./types/lead-generation-create.types";
import {UpdateLeadDto} from "./types/lead-generation-update.types";
import {LeadGenerationQuotePdfDto} from "./types/lead-generation-pdf-types";

export class MyIzenApiService
{
    private static readonly BASE_PATH: string = "/api/leadGeneration";

    getAvailablePackages( buildingType: string, postalCode: string, language: string ): Promise<any>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/availablePackages?buildingType=${buildingType}&postalCode=${postalCode}`, {
            method: 'GET', headers: {
                'accept': '*/*', 'Accept-Language': language
            }
        } ).then( ( res ) => {
            return res.json();
        } ).then( ( json ) => {
            return json;
        } );
    }

    getBaseConfiguration(
        language: string,
        theme: string,
        sourceNewId: string | null,
        sourceExistingId: string | null,
        supportsBelfiusFinancing: string ): Promise<any>
    {
        return fetch(
            `${MyIzenApiService.BASE_PATH}/configuration?theme=${theme}&sourceNew=${sourceNewId}&sourceExisting=${sourceExistingId}&supportsBelfiusFinancing=${supportsBelfiusFinancing}`,
            {
                method: 'GET', headers: {
                    'Accept-Language': language
                }
            } ).then( res => res.json() )
            .then( json => json );
    }

    getConfigurationOptions( language: string ): Promise<LeadGenerationOptions>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/options`, {
            method: 'GET', headers: {
                'Accept-Language': language
            }
        } ).then( res => res.json() )
            .then( json => json );
    }

    getSimulation( solarPanelQuantity: number, batteryQuantity: number, language: string ): Promise<QuoteSimulation>
    {
        const payload = {
            "batteryAmount": batteryQuantity, "solarPanelsAmount": solarPanelQuantity
        };

        return fetch( `${MyIzenApiService.BASE_PATH}/simulation`, {
            method: 'POST', headers: {
                'Accept-Language': language, 'Content-type': 'application/json'
            }, body: JSON.stringify( payload )
        } ).then( res => res.json() )
            .then( json => json );
    }

    /**
     *
     * @summary Allows consumer to create a lead in the MYIZEN 2.0 platform
     * @param {CreateLeadDto} createLeadDto createLeadDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLead( createLeadDto: CreateLeadDto ): Promise<CreateLeadResultDto>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/create`, {
            method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify( createLeadDto )
        } ).then( ( res ) => {
            return res.json();
        } ).then( ( json ) => {
            return json as CreateLeadResultDto;
        } );
    }

    updateLead( updateLeadDto: UpdateLeadDto, contactKey: string, projectId: string ): Promise<any>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/contact/${contactKey}/project/${projectId}`, {
            method: 'PUT', headers: {'Content-Type': 'application/json'}, body: JSON.stringify( updateLeadDto )
        } ).then( ( res ) => {
            return res.json();
        } ).then( ( json ) => {
            return json;
        } );
    }

    createPdf( leadGenerationQuotePdfDto: LeadGenerationQuotePdfDto ): Promise<string | null>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/pdf/render`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify( leadGenerationQuotePdfDto )
        } )
            .then( ( res ) => {
                       if ( !res.ok ) {
                           console.log( "Something went wrong trying to create a pdf" );
                           return null;
                       }
                       return res.text();
                   }
            );
    }

    getPdf( quotePdfIdentifier: string ): Promise<PdfResponse | null>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/pdf/${quotePdfIdentifier}`, {
            method: 'GET'
        } ).then( ( res ) => {
            if ( !res.ok ) {
                return null;
            }
            let header = res.headers.get( "Content-Disposition" );
            let fileName = "quote"
            if ( header !== null ) {
                fileName = header.substring( header.indexOf( "=" ) + 1 );
            }
            return {blob: res.blob(), fileName: fileName};
        } );
    }

    getBelfiusQuote( loanAmount: number | null, language: string ): Promise<QuoteBelfius>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/belfius/simulate?loanAmount=${loanAmount}`, {
            method: 'GET', headers: {
                'accept': '*/*', 'Accept-Language': language
            }
        } ).then( ( res ) => {
            return res.json();
        } ).then( ( json ) => {
            return json;
        } );
    }

    addNotes( formData: FormData, contactKey: string, projectId: string ): Promise<void>
    {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: formData,
        };

        return fetch( `${MyIzenApiService.BASE_PATH}/contact/${contactKey}/project/${projectId}/upload`, requestOptions )
            .then( response => response.text() )
            .then( result => console.log( result ) )
            .catch( error => console.log( 'error', error ) );
    }

    sendConfirmationMail( contactKey: string, projectId: string, language: string ): Promise<any>
    {
        return fetch( `${MyIzenApiService.BASE_PATH}/contact/${contactKey}/project/${projectId}/confirmationMail`, {
            method: 'POST', headers: {
                'Accept-Language': language, 'Content-type': 'application/json'
            }
        } ).then( ( res ) => {
                      if ( !res.ok ) {
                          console.log( "Something went wrong trying to send the confirmationMail" );
                          return null;
                      }
                  }
        );
    }
}

export const izenApiService = new MyIzenApiService();
